<template>
  <el-select
    v-model="selectedShipperGroup"
    @input="emitInput()"
    @change="emitChange()"
    ref="shipper-group-select"
  >
    <el-option
      v-for="shipperGroup in shipperGroupList"
      :key="shipperGroup.id"
      :label="shipperGroup.name"
      :value="shipperGroup.id"
    ></el-option>
  </el-select>
</template>

<script>
import accountService from '@/api/accountService';

const shipperGroupNone = 0;

export default {
  name: 'ShipperGroupSelect',
  props: ['value', 'includeOptionAll', 'includeOptionNone'],
  data() {
    return {
      selectedShipperGroup: this.value,
      shipperGroupList: []
    };
  },
  mounted() {
    if (this.includeOptionAll) {
      this.shipperGroupList = [
        {
          id: null,
          name: this.$t('common.all')
        }
      ];
    }

    if (this.includeOptionNone) {
      this.shipperGroupList.push({
        id: shipperGroupNone,
        name: this.$t('common.none')
      });
    }

    accountService.getShipperGroups().then((response) => {
      this.shipperGroupList = this.shipperGroupList.concat(
        response.data.map(shipperGroup => ({
          id: shipperGroup.id,
          name: shipperGroup.name
        }))
      );
    });
  },
  methods: {
    emitInput() {
      this.$emit('update:value', this.selectedShipperGroup);
      this.$emit('input', this.selectedShipperGroup);
    },
    emitChange() {
      this.$emit('update:value', this.selectedShipperGroup);
      this.$emit('change', this.selectedShipperGroup);
    },
    setSelectedShipperGroup(selected) {
      this.selectedShipperGroup = selected;
    }
  }
};
</script>
